






















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../../store.vuex';
import viewAttachmentsPopUp from './viewAttachmentsPopUp.vue';
import sanitizeHtml from 'sanitize-html';

@Component({
    name: 'Inbox',
    components: {
        viewAttachmentsPopUp,
    },
})
export default class Inbox extends Vue {

    private emailResponses: any = [];
    private isLoggedIn:boolean=false;
    private token:any="";
    private userId = 0
    private userEmailBody: string = ""
    private docBasePath: string = ""
    private uploadedFileName: any = []
    private files:any =[]
    private height:number=0
    private windowResize:boolean=false;
    $wlToastr: any;


  async mounted() {
    this.isLoggedIn =  vxm.users.isLoggedIn;
    const queryParams = this.$route.query;
    const isToken = queryParams.hasOwnProperty('token');
    if (isToken) {
      this.token = this.$route.query.token;
    }
    this.windowResize = true;
    if (this.isLoggedIn) {
      this.userId = vxm.users.myUserProfile.userId;
      if (this.userId == 0) {
        var details = await vxm.users.updatedUserProfile();
        this.userId = vxm.users.myUserProfile.userId;
      }
      this.handleResize();
      if (this.userId != 0) {
        this.fetchEmailConversation();
      }
    } else {
      this.fetchEmailConversation();
    }
        window.addEventListener('resize', this.handleResize);
    }

    setContainerHeight(){
        var content:any =document.getElementById('content');
       var chatContainer:any = document.getElementById('chatContainer');
       if(content && content.offsetHeight && content.offsetHeight>= this.height){
          content.classList.remove('postionContent');
       }
       chatContainer.scrollTop = chatContainer.scrollHeight;
    }
    formatTimeZone(gmtTime){
        const gmtTimeZone = new Date(gmtTime+ " GMT");
const userLanguage = navigator.language || "en-US";
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const formattedLocalTime = gmtTimeZone.toLocaleString(userLanguage, {
        timeZone: userTimezone,
      });

      return formattedLocalTime;
    }
    onCancel(filename) {
        var timesicon:any = document.getElementsByClassName('timesicon');
        var background:any= document.getElementsByClassName('resumeSpan');
        
        for(var i=0; i<this.uploadedFileName.length;i++){
            if(this.uploadedFileName[i] == filename){
        //         background[i].classList.remove('addbackground')
        // timesicon[i].style.display="none"
        this.uploadedFileName.splice(i, 1);
        this.files.splice(i,1);
        var file: any = document.getElementById('file-upload')
        // file[i].value = '';
      }
    }
  }
  viewAttachedDocument(conversation: any) {
    var extension = conversation.downloadLink.split('.');
    var attachmentUrl = this.getattachmentUrl(conversation);
    var isPdf = false;
    if (extension[1].toLowerCase() == 'pdf') {
      isPdf = true;
    }

    this.$modal.show(
      viewAttachmentsPopUp,
      {
        header: this.$t('inbox.modal.viewAttachmentHeader'),
        attachmentUrl: attachmentUrl,
        isPdf: isPdf,
        downLoadFileName: this.getDownloadFileName(conversation),
      },
      {
        height: 'auto',
        clickToClose: false,
        class: 'mainclass',
      },
    );
  }

  viewAttachedUserDocument() {
    const fileInput: any = document.getElementById('file-upload');

    // var extension = fileInput.files[0].name
    var isPdf = false;
    // if (extension[1].toLowerCase() == 'pdf') {
    //     isPdf = true;
    // }

    this.$modal.show(
      viewAttachmentsPopUp,
      {
        header: this.$t('inbox.modal.viewAttachmentHeader'),
        attachmentUrl: fileInput.files[0],
        isPdf: isPdf,
      },
      {
        height: 'auto',
        clickToClose: false,
        class: 'mainclass',
      },
    );
  }

  getattachmentUrl(conversation) {
    return '/atsuser' + conversation.downloadLink;
  }
  getUserUploadUrl() {
    const fileInput: any = document.getElementById('file-upload');

    return fileInput.files[0];
  }
  getDownloadFileName(conversation) {
    return conversation.fileName.split('.')[0];
  }

  handleResize() {
    var windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    var chatArea: any = document.getElementById('chatArea');
    var setHeight: any = document.getElementById('chatContainer');
    var footer: any = document.getElementsByClassName('footer-container');
    if(footer && footer[0] && footer[0].offsetHeight){
     var bottomLength = footer[0].offsetHeight + 190;
    }
    if(chatArea && chatArea.offsetHeight){
      setHeight.style.height =   chatArea.offsetHeight - bottomLength + 'px' ;
      this.height = windowHeight - (chatArea.offsetHeight - bottomLength);
    }
    setTimeout(() => {
      document.getElementsByClassName('bottomFix')[0].scrollIntoView({
        behavior: 'smooth',

        block: 'start',

        inline: 'nearest',
      });
    }, 100);
  }

  uploadedFile(e) {
    // background[0].classList.add('addbackground')
    // timesicon[0].style.display="inline"
    this.files.push(e.target.files[0]);
    this.uploadedFileName.push(e.target.files[0].name);

    console.log('Selected file: ' + e);
  }
  async fetchEmailConversation() {
    if (this.isLoggedIn) {
      var response: any = await vxm.users.fetchInMailChatConversation(
        this.userId,
      );
    } else {
      var response: any = await vxm.users.fetchAnonInMailChatConversation(
        this.token,
      );
    }
    this.emailResponses = response.data.emailConversationResponse;
    setTimeout(() => {
      this.setContainerHeight();
    }, 50);

    if (this.windowResize) {
      setTimeout(() => {
        this.windowResize = false;
        document.getElementsByClassName('bottomFix')[0].scrollIntoView({
          behavior: 'smooth',

          block: 'start',

          inline: 'nearest',
        });
      }, 100);
    }
  }

  async sendInChatEmail() {
    if (this.userEmailBody.length >= 3) {
      const fileInput: any = document.getElementById('file-upload');

      const file = fileInput.files[0];
      const formData = new FormData();

      const formattedHtml = this.userEmailBody.replace(/\n/g, '<br>');
      var sanitizedHtml = sanitizeHtml(formattedHtml);
      formData.append('subject', '');
      formData.append('body', sanitizedHtml);
      if (this.files.length > 0) {
        for (var i = 0; i < this.files.length; i++) {
          formData.append('attachments', this.files[i]);
        }
      }
      //    formData.append('attachments', null);
      if (this.isLoggedIn) {
        var resp = await vxm.users.sendInMailChatConversation(formData);
      } else {
        formData.append('token', this.token);
        var resp = await vxm.users.sendInMailAnonChatConversation(formData);
      }
      console.log(resp);

      this.$wlToastr('success', resp.meta.displayMessage, '');
      this.userEmailBody = '';
      this.files = [];
      this.uploadedFileName = [];

      this.fetchEmailConversation();
    } else {
      this.$wlToastr('error', this.$t('inbox.message.invalidEmailBody'), '');
    }
  }
}
